import { render, staticRenderFns } from "./Grecharge.vue?vue&type=template&id=1a1827a7&scoped=true"
import script from "./Grecharge.vue?vue&type=script&lang=js"
export * from "./Grecharge.vue?vue&type=script&lang=js"
import style0 from "./Grecharge.vue?vue&type=style&index=0&id=1a1827a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1827a7",
  null
  
)

export default component.exports